import React, { useState } from 'react';

const AppConfirmDialog = ({
    id = "confirm_modal",
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    icon = "pi pi-exclamation-triangle",
    iconColor = "text-warning",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    onConfirm,
    confirmStyle = "btn-success text-white",
    cancelStyle = "btn-ghost"
}) => {
    const [isProcessing, setIsProcessing] = useState(false);

    const handleConfirmClick = async (e) => {
        if (onConfirm) {
            setIsProcessing(true);
            try {
                await onConfirm(e);
            } finally {
                setIsProcessing(false);
                const modal = document.getElementById(id);
                if (modal) modal.close();
            }
        } else {
            const modal = document.getElementById(id);
            if (modal) modal.close();
        }
    };

    return (
        <dialog id={id} className="modal modal-bottom sm:modal-middle transition-all">
            <div className="modal-box text-center p-8 rounded-3xl shadow-xl">
                {/* Large Icon */}
                <div className={`mx-auto bg-base-200 w-28 h-28 rounded-full flex items-center justify-center mb-6`}>
                    <i className={`${icon} ${iconColor}`} style={{ fontSize: "4rem" }}></i>
                </div>
                
                {/* Text Content */}
                <h3 className="font-bold text-2xl mb-2 text-base-content">{title}</h3>
                <p className="py-2 text-base-content/70">{message}</p>
                
                {/* Action Buttons */}
                <div className="modal-action flex justify-center gap-4 mt-8">
                    <div className="flex gap-4">
                        <button 
                            type="button"
                            className={`btn rounded-full px-8 shadow-sm ${confirmStyle}`} 
                            disabled={isProcessing}
                            onClick={handleConfirmClick}
                        >
                            {isProcessing ? <span className="loading loading-spinner"></span> : <i className="pi pi-check-circle text-lg mr-1"></i>}
                            {isProcessing ? "Processing..." : confirmLabel}
                        </button>
                        <button 
                            type="button"
                            disabled={isProcessing}
                            onClick={() => { document.getElementById(id).close(); }}
                            className={`btn rounded-full px-8 ${cancelStyle}`}
                        >
                            <i className="pi pi-times-circle text-lg mr-1"></i>
                            {cancelLabel}
                        </button>
                    </div>
                </div>
            </div>
            {/* Click outside to close backdrop */}
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    );
};

export default AppConfirmDialog;
